"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainException = void 0;
const base_exception_1 = require("./base.exception");
/**
 * - Domain exceptions are expected exceptions.
 * - Encountering them and throwing them is a part of the design of the system.
 * - They are not syntax errors or bugs in the code.
 * - Many can be handled gracefully.
 */
class DomainException extends base_exception_1.BaseException {
}
exports.DomainException = DomainException;
